import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Component
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SignupComponent } from './components/signup/signup.component';
import { UploadFormComponent } from './components/uploads/upload-form/upload-form.component';
import { RegisterComponent} from './components/register/register.component';
// date
import { MyDatePickerModule } from 'mydatepicker'

// Routes
export const router: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'testup',component:UploadFormComponent},
  { path: 'priceuser',component:PriceuserComponent},

]
import { AngularFireDatabaseModule} from 'angularfire2/database'; 
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { UiModule } from './ui/ui.module';
import { from } from 'rxjs';
import { PriceuserComponent } from './components/priceuser/priceuser.component';

import { MatCardModule} from '@angular/material/card';
import { MatSelectModule, MatButtonModule } from '@angular/material';
export const firebaseConfig = {
  apiKey: "AIzaSyBeRP7haATtWWKkXNZjwKPgOJrU3PpXqYc",
  authDomain: "bacaraproject-6e846.firebaseapp.com",
  databaseURL: "https://bacaraproject-6e846.firebaseio.com",
  projectId: "bacaraproject-6e846",
  storageBucket: "bacaraproject-6e846.appspot.com",
  messagingSenderId: "973962695019",
  appId: "1:973962695019:web:3aab2680f83adc639dbc2e",
  measurementId: "G-GEREB012CZ"
 };
 import { MDBBootstrapModule } from 'angular-bootstrap-md';


@NgModule({

  declarations: [

    AppComponent,
    HomeComponent,
    LoginComponent,
    NavbarComponent,
    ProfileComponent,
    SignupComponent,
    UploadFormComponent,
    PriceuserComponent,
    RegisterComponent,
  ],
  imports: [
    MatSelectModule,
    MatButtonModule,
    MatCardModule,
    MyDatePickerModule,
    FormsModule,
    BrowserModule,
    RouterModule.forRoot(router),
    MDBBootstrapModule.forRoot(),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(firebaseConfig),
    UiModule
  ],
  
  providers: [AngularFireDatabase],
  bootstrap: [AppComponent]
})
export class AppModule { }